module.exports = __webpack_public_path__ + "5c021c1d916534b15b49df8514477509.svg";